

type ImageInfo = {
  src: string;
  desc: string;
};

const finished_works1: ImageInfo[] = [
  {
    src: "/images/art/b3.jpg",
    desc: "collage + watercolor",
  },
  {
    src: "/images/art/10.png",
    desc: "acrylic painting",
  },
  {
    src: "/images/art/C2.jpg",
    desc: "acrylic painting",
  },
  {
    src: "/images/art/zhongli.jpg",
    desc: "digital",
  },
  {
    src: "/images/art/B5.jpg",
    desc: "'me and my sister, 2004' (colored pencil)",
  },
  // {
  //   src: "/images/art/2.png",
  //   desc: "watercolor",
  // },
  // {
  //   src: "/images/art/3.png",
  //   desc: "charcoal",
  // },
  {
    src: "/images/art/feather.jpg",
    desc: "pencil",
  },
  {
    src: "/images/art/9.png",
    desc: "watercolor",
  },
];

const finished_works2: ImageInfo[] = [
  {
    src: "/images/art/C9.jpg",
    desc: "acrylic painting",
  },
  {
    src: "/images/art/C4.jpg",
    desc: "acrylic painting",
  },
  {
    src: "/images/art/C6.jpg",
    desc: "'you can't read in your dreams' (acrylic painting)",
  },
  {
    src: "/images/art/xiao.jpg",
    desc: "digital",
  },
  {
    src: "/images/art/1.png",
    desc: "acrylic + oil",
  },
  {
    src: "/images/art/5.png",
    desc: "gouache + colored pencil",
  },
  {
    src: "/images/art/7.png",
    desc: "charcoal",
  },
  {
    src: "/images/art/C10.jpg",
    desc: "'driving in your dreams pt 2' (acrylic painting)",
  },
];

const finished_works3: ImageInfo[] = [
  {
    src: "/images/art/C7.jpg",
    desc: "acrylic painting",
  },
  {
    src: "/images/art/C1.jpg",
    desc: "acrylic painting",
  },
  {
    src: "/images/art/C5.jpg",
    desc: "'driving in your dreams' (acrylic painting)",
  },
  {
    src: "/images/art/kazuha.jpg",
    desc: "digital",
  },
  {
    src: "/images/art/4.jpg",
    desc: "ink stippling",
  },
  {
    src: "/images/art/6.png",
    desc: "gouache",
  },
  {
    src: "/images/art/8.png",
    desc: "charcoal",
  },
];

const sketches: ImageInfo[] = [

];

export { finished_works1, finished_works2, finished_works3, sketches };
